export default __webpack_public_path__ + "static/media/ourWig-silkTop.c9406f9a.jpeg";